import { createContext, useContext, useEffect, useMemo, useState } from "react"
import * as apiObject from "api/apiObjects";
import useSettingsParams from "hooks/useSettingsParams";
import { isObjectEditLocked } from "utils/helpers/objects/isObjectEditLocked";
import vconst from "utils/helpers/structs/vconst";
import { _localGet, _localSet } from "utils/helpers/gimHelper";

const SHOW_ANALYTICS_STORAGE_KEY = 'objectCardShowAnalytics';

const readShowAnalytics = () => {
    try {
        const raw = _localGet(SHOW_ANALYTICS_STORAGE_KEY);
        if (raw === null || typeof raw === 'undefined') return true;
        return raw === '1';
    } catch {
        return true;
    }
};

const ObjectCardContext = createContext();
export const useObjectCard = () => useContext(ObjectCardContext);

export const ObjectCardProvider = ({objectId, onlySale: onlySaleProp = false, children}) => {
    const params = useSettingsParams();
    const onlySale = Boolean(onlySaleProp);

    const [ vObject, setVObject ] = useState(null);
    const [ showSpinner, setShowSpinner ] = useState(false);
    const [ vObjectInfo, setVObjectInfo ] = useState(null);
    const [ showAnalytics, setShowAnalyticsState ] = useState(readShowAnalytics);

    const setShowAnalytics = (next) => {
        setShowAnalyticsState((prev) => {
            const value = typeof next === 'function' ? next(prev) : Boolean(next);
            try {
                _localSet(SHOW_ANALYTICS_STORAGE_KEY, value ? '1' : '0');
            } catch {
                /* ignore storage errors */
            }
            return value;
        });
    };

    const applyPayStatusSync = async (targetObjectId) => {
        if (!params.objectPaymentControl || !params.autoSyncPayStatus) return;
        const sync = await apiObject.syncPayStatusIfCovered(targetObjectId);
        if (!sync?.updated) return;
        setVObject((prev) => {
            if (!prev?.object) return prev;
            return {
                ...prev,
                object: {
                    ...prev.object,
                    objectPayStatus: sync.payStatus,
                },
            };
        });
    }; 

    const fetchObject = async () => {
        if (!objectId) {
            setVObject(null);
            return;
        }
        setShowSpinner(true);
        const resObject = await apiObject.getObject(objectId);
        setVObject(resObject);
        setShowSpinner(false);
        // Фон: синхронізація статусу оплати за документами (0 / 1 / 2)
        if (resObject?.object?.ID) {
            void applyPayStatusSync(objectId);
        }
    };
 
    useEffect(()=>{
        let prodPrice = 0;
        let prodPriceRate = 0;
        let prodPriceSale = 0;
        let prodPriceSaleRate = 0;
        vObject?.operations
            ?.filter(o=>o.operStatus === vconst.operStatApproved)
            ?.map(o=>{
                prodPrice = prodPrice + o.operPrice*o.operCount;
                prodPriceRate = prodPriceSale + o.operPriceRate*o.operCount;
                prodPriceSale = prodPriceSale + o.operPriceSale*o.operCount;
                prodPriceSaleRate = prodPriceSaleRate + o.operPriceSaleRate*o.operCount; 
            });

        setVObjectInfo({
            prodPrice,
            prodPriceRate,
            prodPriceSale,
            prodPriceSaleRate,
            
        })
    },[vObject])

    const isEditLocked = useMemo(
        () => isObjectEditLocked(vObject?.object?.objectStatus, params),
        [vObject?.object?.objectStatus, params.lockFinishedObject],
    );
     
    return (
        <ObjectCardContext.Provider 
            value={{
                objectId,
                vObjectInfo,
                vObject,
                setVObject,
                fetchObject,
                showSpinner, 
                setShowSpinner,
                showAnalytics,
                setShowAnalytics,
                isEditLocked,
                onlySale,
            }}>
            {children}
        </ObjectCardContext.Provider>
    )
}